import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '/#about'
  }, {
    name: 'Services',
    href: '/#services'
  }, {
    name: 'Doctor',
    href: '/#team'
  }, {
    name: 'Appointments',
    href: '/appointments'
  }, {
    name: 'Contact',
    href: '/#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-charcoal-600 ${isScrolled ? 'shadow-lg py-3' : 'py-5'}`} data-id="element-150">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between" data-id="element-151">
        <a href="#" className="flex items-center group focus:outline-none focus-visible:ring-2 focus-visible:ring-sage focus-visible:ring-offset-2 focus-visible:ring-offset-charcoal-600 rounded-lg" aria-label="Dennis Martin DDS — Home" data-id="element-152">
          <img src="https://dennismartindds.com/index_htm_files/236@2x.png" alt="Dennis Martin DDS" className="h-12 md:h-14 w-auto transition-transform group-hover:scale-105" data-id="element-153" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-154">
          <ul className="flex items-center gap-8" data-id="element-155">
            {navLinks.map(link => <li key={link.name} data-id="element-156">
                <a href={link.href} className="text-charcoal-100 hover:text-sage font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-sage focus-visible:ring-offset-2 focus-visible:ring-offset-charcoal-600 rounded px-1" data-id="element-157">
                  {link.name}
                </a>
              </li>)}
          </ul>
          <a href="#book" className="bg-sage hover:bg-sage-600 text-white px-6 py-3 rounded-full font-medium transition-all hover:shadow-lg hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-sage focus-visible:ring-offset-2 focus-visible:ring-offset-charcoal-600" data-id="element-158">
            Book Appointment
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden p-2 text-charcoal-100 hover:text-sage focus:outline-none focus-visible:ring-2 focus-visible:ring-sage rounded-lg" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-159">
          {isMobileMenuOpen ? <X size={24} data-id="element-160" /> : <Menu size={24} data-id="element-161" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-162">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-charcoal-600 border-t border-charcoal-500 overflow-hidden" data-id="element-163">
            <div className="px-6 py-6 flex flex-col gap-2" data-id="element-164">
              {navLinks.map(link => <Link key={link.name} to={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-lg font-medium text-charcoal-50 hover:text-sage py-3 border-b border-charcoal-500" data-id="element-165">
                  {link.name}
                </Link>)}
              <Link to="/appointments" onClick={() => setIsMobileMenuOpen(false)} className="bg-sage text-white text-center px-6 py-4 rounded-xl font-medium mt-4 shadow-sm" data-id="element-166">
                Book Appointment
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}